export const HO_CONTACT_NUMBERS = [
  {
    countryName: '🇺🇸  United States of America',
    phoneNumber: '+1 347 897 0100',
    ctaType: 'USA phone number',
  },
  {
    countryName: '🇬🇧  United Kingdom',
    phoneNumber: '+44 117 325 5305',
    ctaType: 'UK phone number',
  },
  {
    countryName: '🇪🇸  Spain',
    phoneNumber: '+34 930 34 94 65',
    ctaType: 'Spain phone number',
  },
  {
    countryName: '🇦🇺  Australia',
    phoneNumber: '+61 489 072 695',
    ctaType: 'Australia phone number',
  },
  {
    countryName: '🇦🇪  United Arab Emirates',
    phoneNumber: '+971 8 000 321171',
    ctaType: 'UAE phone number',
  },
  {
    countryName: '🇸🇬  Singapore',
    phoneNumber: '+65 3135 1295',
    ctaType: 'Singapore phone number',
  },
  {
    countryName: '🇮🇹  Italy',
    phoneNumber: '+39 02 4013 6894',
    ctaType: 'Italy phone number',
  },
  {
    countryName: '🇩🇪  Germany',
    phoneNumber: '+49 30 21927376',
    ctaType: 'Germany phone number',
  },
];
